import FindPlan from '~components/FindPlan/FindPlan';
import useWindowSize from '~hooks/useWindowSize';

const ZipContainer = ({ children }: React.PropsWithChildren) => {
    const { isDesktop } = useWindowSize();

    return (
        <>
            {isDesktop && <FindPlan title="See plans in your area instantly!" useFlexRow />}
            {children}
        </>
    );
};

export default ZipContainer;
